export default __webpack_public_path__ + "static/media/DSC02601.f46f5589.jpg";